export const MEGA_LINKS = [
    "/tracks/all",
    "/tracks/top",
    "/tracks/rank",
    "/tracks/curated"
];
